var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcOutWhite = function SvgIcOutWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21 3V2h1v1zm-9.293 10.707a1 1 0 0 1-1.414-1.414zM20 11V3h2v8zm1-7h-8V2h8zm.707-.293-10 10-1.414-1.414 10-10z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M20 15c0 1.87 0 2.804-.402 3.5a3 3 0 0 1-1.098 1.098C17.804 20 16.87 20 15 20h-5c-2.828 0-4.243 0-5.121-.879C4 18.243 4 16.828 4 14V9c0-1.87 0-2.804.402-3.5A3 3 0 0 1 5.5 4.402C6.196 4 7.13 4 9 4"
  })));
};
export default SvgIcOutWhite;